import React, { useState, useEffect } from "react";
import Header from "../components/Header";
import Hero from "../components/Hero";
import AboutBook from "../components/AboutBook";
import Author from "../components/Author";
import BookContent from "../components/BookContent";
import PurchaseOptions from "../components/PurchaseOptions";
import FAQ from "../components/FAQ";
import Footer from "../components/Footer";

const HomePage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <Hero />
      <AboutBook />
      <Author />
      <BookContent />
      <PurchaseOptions />
      <FAQ />
      <Footer />
    </div>
  );
};

export default HomePage;